import PropTypes from "prop-types"

export const Discount = ({ amount }) => {
  if (!amount) {
    return null
  }
  return `-${amount}%`
}

Discount.propTypes = {
  amount: PropTypes.number.isRequired,
}
